import { ReactNode } from 'react';
import { Empty } from '@arco-design/web-react';
import { IconEmpty } from '@arco-design/web-react/icon';

export interface EmptyStateProps {
  /** 空态文案，默认「暂无数据」 */
  description?: ReactNode;
  /** 插画/图标占位，默认 IconEmpty */
  icon?: ReactNode;
  /** 引导操作（如新建按钮） */
  action?: ReactNode;
}

export default function EmptyState({ description = '暂无数据', icon, action }: EmptyStateProps) {
  return (
    <div className="bcc-empty">
      <Empty
        icon={
          <div className="bcc-empty-icon">
            {icon ?? <IconEmpty />}
          </div>
        }
        description={description}
      />
      {action && <div style={{ marginTop: 12 }}>{action}</div>}
    </div>
  );
}
